const h = (e) => {
  if (!e || isNaN(Date.parse(e)))
    return "";
  const t = new Date(e), n = new Date(
    Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate())
  );
  return new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    timeZone: "UTC"
  }).format(n);
}, l = (e) => {
  if (!e || isNaN(Date.parse(e)))
    return { date: "", time: "" };
  const t = new Date(e).toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }), n = new Date(e).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit"
  });
  return { date: t, time: n };
}, M = (e) => {
  const t = /* @__PURE__ */ new Date(), n = /* @__PURE__ */ new Date();
  return e === 30 ? n.setDate(t.getDate() - e) : n.setMonth(t.getMonth() - e), n.toISOString().split("T")[0];
}, T = () => (/* @__PURE__ */ new Date()).toISOString().split("T")[0], w = (e) => {
  if (!e || isNaN(Date.parse(e)))
    return "";
  const t = new Date(e), o = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ][t.getMonth()], r = t.getDate(), i = t.getFullYear(), g = (a) => {
    if (a >= 11 && a <= 13) return `${a}th`;
    const u = a % 10;
    return `${a}${["st", "nd", "rd"][u - 1] || "th"}`;
  }, s = t.getHours(), c = t.getMinutes(), D = s % 12 || 12, m = s >= 12 ? "PM" : "AM";
  return `${o} ${g(r)} ${i} at ${D}:${c.toString().padStart(2, "0")} ${m}`;
}, S = (e) => {
  const t = /* @__PURE__ */ new Date();
  return t.setMonth(t.getMonth() - e), t.setDate(t.getDate() + 1), t.toISOString().split("T")[0] ?? "";
}, d = (e, t) => {
  const n = typeof t == "string" ? new Date(t) : t, o = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(n.getFullYear(), n.getMonth(), n.getDate());
  return o.getTime() < r.getTime() && o.getDate() !== r.getDate();
};
export {
  l as a,
  h as b,
  S as c,
  T as g,
  d as i,
  w as p,
  M as t
};
